import {Alert, Button, Col, Row, Space} from "antd";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {OfferingAutomations} from "../../../../../components/offering-form/automations-step";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {useCreateBundleContext} from "../../context/create-bundle";
import {useSession} from "../../../../../features/sessions";
import {FullPageLoader} from "../../../../../components/full-page-loader";
import {CreateServiceSuccessModal} from "../../../createService/success-modal";
import {
  OFFERING_CREATE_DRAFT_KEYS,
  useClearOfferingCreateDraft,
} from "../../../../../utils/offering-create-draft";

export function CreateBundleAutomationsStep() {
  const navigate = useNavigate();
  const {
    dispatch,
    state: {apiResponseData},
  } = useCreateBundleContext();
  const [openSuccessfulModal, setOpenSuccessfulModal] = useState(false);
  const clearBundleDraft = useClearOfferingCreateDraft(OFFERING_CREATE_DRAFT_KEYS.bundle);

  const bundleId = apiResponseData?.id ? Number(apiResponseData.id) : 0;
  const getBundleQuery = useSession(bundleId, bundleId > 0);

  if (getBundleQuery.isLoading) {
    return <FullPageLoader />;
  }

  if (getBundleQuery.isError) {
    return (
      <Alert
        message="Error"
        description={getBundleQuery.error.message}
        type="error"
        showIcon
      />
    );
  }

  const bundle = getBundleQuery.data!;

  const goBack = () =>
    dispatch({
      type: "update-create-bundle-form-step",
      payload: "coverImagesUpload",
    });

  const handleModalOk = () => {
    setOpenSuccessfulModal(false);
    clearBundleDraft();
    navigate("/calls");
  };

  return (
    <>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <OfferingAutomations
          contextOfferingId={bundle.id}
          onPublishSuccess={() => setOpenSuccessfulModal(true)}
          renderWizardFooter={() => (
            <Row gutter={[0, 16]}>
              <Col span={24} sm={12}>
                <StyledServiceButtonWrapper>
                  <Button onClick={goBack} block size="small" type="default">
                    Back
                  </Button>
                  <Button
                    block
                    type="primary"
                    size="small"
                    onClick={() => setOpenSuccessfulModal(true)}
                  >
                    Create bundle
                  </Button>
                </StyledServiceButtonWrapper>
              </Col>
            </Row>
          )}
        />
      </Space>
      <CreateServiceSuccessModal
        openSuccessfulModal={openSuccessfulModal}
        handleOk={handleModalOk}
        slug={bundle.slug}
        serviceId={bundle.id}
        serviceName={bundle.name}
        modalDescription="Your bundle has been successfully created! Share your session link to start getting bookings"
        modalTitle="Bundle created!"
        tinyUrl={bundle.tinyUrl}
      />
    </>
  );
}
